<template>
    <div>
        <van-nav-bar
                title="出库查询"
                left-text=""
                right-text="筛选"
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
                v-if="show"
        />
        <!--    <van-sticky :offset-top="45">-->
        <!--      <div class="hejcss">-->
        <!--        合计：提单{{ outCount }}笔，提货数量{{ sumAmount }}件，重量{{-->
        <!--          sumWeight == '&#45;&#45;' ? '&#45;&#45;' : (sumWeight / 1000).toFixed(3)-->
        <!--        }}吨-->
        <!--      </div>-->
        <!--    </van-sticky>-->
        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list style="padding-bottom: 100px"
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <van-cell v-for="item in list" :key="item.outnotifyId" class="swipewarp"
                              @click="showDetail(true, item)">
                        <van-row gutter="20">
                            <van-col span="16" class="ellipsis">
                                提货单号：{{ item.outnotifyNo }}
                            </van-col>
                            <van-col span="8" class="ellipsisRight">
                                状态：{{conventStatus(item)}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="15" class="ellipsis">
                                货主提单号：{{ item.outnotifyCustomerNo }}
                            </van-col>
                            <van-col span="9" class="ellipsisRight">
                                车号：{{ item.deliveryTrucknumber }}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="10" class="ellipsis">
                                品名：{{ item.cargoProcessName }}
                            </van-col>
                            <van-col span="14" class="ellipsisRight">
                                数量： {{ item.totalAmount }}件/{{ item.totalWeight }}公斤
                            </van-col>
                        </van-row>
                    </van-cell>
                </van-list>
            </van-pull-refresh>
        </div>
        <van-popup v-model="searchShowPop" position="right" :style="{ height: '100%', width:'90%'}">
            <van-nav-bar
                    title="筛选"
                    fixed
                    z-index="9000"
                    left-arrow
                    @click-left="() => this.searchShowPop = false"
            />
            <div class="searchwarp">
                <van-field v-model="searchValue.outnotifyNo" label="关键字" placeholder="请输入提货单号\货主单号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.deliveryTrucknumber" label="提货车号" placeholder="请输入提货车号"
                           autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.instockDate" label="出库日期" readonly="readonly" placeholder="点击选择日期"
                           autocomplete="off"
                           @click="showPicker('calendarShow')" label-width="80px" label-align="right"/>
                <van-field :value="status" readonly name="picker" label="状态" placeholder="点击选择状态"
                           @click="showPicker('showPickerSta')"
                           label-width="80px" label-align="right"/>
                <!--        <van-field v-model="searchValue.key" label="查询条件" placeholder="钢卷号/物料号/包装号" autocomplete="off"-->
                <!--                   label-width="80px" label-align="right"/>-->
                <van-field :value="selCargoProcessName" readonly name="picker" label="品名" placeholder="点击选择品名"
                           @click="showPicker('showPickerCar')" label-width="80px" label-align="right"/>
                <!--        <van-field v-model="searchValue.modelH" label="规格厚" placeholder="请输入规格厚" autocomplete="off"-->
                <!--                   label-width="80px" label-align="right"/>-->
                <!--        <van-field v-model="searchValue.modelK" label="规格宽" placeholder="请输入规格厚" autocomplete="off"-->
                <!--                   label-width="80px" label-align="right"/>-->
                <!--        <van-field v-model="searchValue.modelC" label="规格长" placeholder="请输入规格厚" autocomplete="off"-->
                <!--                   label-width="80px" label-align="right"/>-->
                <!--        <van-field :value="selPcmode" readonly name="picker" label="属性" placeholder="点击选择属性"-->
                <!--                   @click="showPicker('showPickerMode')"-->
                <!--                   label-width="80px" label-align="right"/>-->
                <!--        <van-field :value="selCargoMaterialName" readonly name="picker" label="材质" placeholder="点击选择材质"-->
                <!--                   @click="showPicker('showPickerMat')" label-width="80px" label-align="right"/>-->
                <!--        <van-field :value="cargoOriginName" readonly name="picker" label="产地" placeholder="点击选择产地"-->
                <!--                   @click="showPicker('showPickerOri')" label-width="80px" label-align="right"/>-->
                <!--        <van-field :value="surfaceName" readonly name="picker" label="表面" placeholder="点击选择表面"-->
                <!--                   @click="showPicker('showPickerSur')" label-width="80px" label-align="right"/>-->

                <van-calendar v-model="calendarShow"
                              :min-date=" new Date(2020, 9, 1)"
                              :default-date="[new Date((new Date()-7000*60*60*24)),new Date() ]"
                              type="range" @confirm="calendarConfirm"/>
                <van-picker
                        title="状态"
                        v-if="showPickerSta"
                        show-toolbar
                        :columns="statusCol"
                        @confirm="selStatusVal"
                        @cancel="showPickerSta = false"
                />
                <van-picker
                        title="品名"
                        v-if="showPickerCar"
                        show-toolbar
                        :columns="cargoNamecol"
                        @confirm="selCargoProcessVal"
                        @cancel="showPickerCar = false"
                />
                <van-picker
                        title="属性"
                        v-if="showPickerMode"
                        show-toolbar
                        :columns="pcmodeCol"
                        @confirm="selPcmodeVal"
                        @cancel="showPickerMode = false"
                />
                <van-picker
                        title="材质"
                        v-if="showPickerMat"
                        show-toolbar
                        :columns="cargoMaterialcol"
                        @confirm="selCargoMaterialVal"
                        @cancel="showPickerMat = false"
                />
                <van-picker
                        title="产地"
                        v-if="showPickerOri"
                        show-toolbar
                        :columns="cargoOrigincol"
                        @confirm="selCargoOriginVal"
                        @cancel="showPickerOri = false"
                />
                <van-picker
                        title="表面"
                        v-if="showPickerSur"
                        show-toolbar
                        :columns="surfaceCol"
                        @confirm="selSurfaceVal"
                        @cancel="showPickerSur = false"
                />
                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="8" offset="4">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>
            </div>
        </van-popup>
        <van-popup v-model="searchDetailPop" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
            <van-nav-bar
                    title="出库明细"
                    left-arrow
                    @click-left="showDetail(false)"
            />
            <div style="height:calc(100vh - 50px); overflow: auto;">
            <div class="van-doc-demo-block">
                <van-row>
                    <van-col span="12"><h2 class="van-doc-demo-block__title">{{ outnotifyNo }}</h2></van-col>
                    <van-col span="12"><h2 class="van-doc-demo-block__title" style="text-align: right">{{ outnotifyStatus | formatStatus }}</h2></van-col>
                </van-row>
                <div class="van-cell-group van-hairline--bottom">
                    <div class="van-cell">
                        <div class="van-cell__title"><span>审核时间</span></div>
                        <div class="van-cell__value"><span>{{ confirmTime }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>客户单号</span></div>
                        <div class="van-cell__value"><span>{{ outnotifyCustomerNo }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>提货车号</span></div>
                        <div class="van-cell__value"><span>{{ deliveryTrucknumber }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>提货人</span></div>
                        <div class="van-cell__value"><span>{{ deliveryName }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>提单有效日期</span></div>
                        <div class="van-cell__value"><span>{{ effectiveDate }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>备注</span></div>
                        <div class="van-cell__value"><span>{{ remarks }}</span></div>
                    </div>
                </div>
            </div>
<!--            <van-cell>-->
<!--                <van-row gutter="20">-->
<!--                    <van-col span="10" class="ellipsis" style="font-weight: bold;font-size: 16px">-->
<!--                        {{ outnotifyNo }}-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight" style="font-weight: bold;font-size: 16px">-->
<!--                        {{ outnotifyStatus | formatStatus }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        审核时间-->
<!--                    </van-col>-->
<!--                    <van-col span="14"-->
<!--                             style="text-align: right; overflow: hidden; white-space:nowrap; text-overflow: ellipsis;">-->
<!--                        {{ confirmTime }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        客户单号-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ outnotifyCustomerNo }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        提货车号-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ deliveryTrucknumber }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        提货人-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ deliveryName }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        提单有效日期-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ effectiveDate }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        备注-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ remarks }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--            </van-cell>-->
            <van-row>
                <van-col span="6"><h2 class="van-doc-demo-block__title">出库明细</h2></van-col>
                <van-col span="18">
                    <h2 class="van-doc-demo-block__title" style="text-align: right;">
                        合计：{{pacTotalCount}}包，{{totalCount}}件，重量{{ (totalWeight / 1000).toFixed(3) }}吨
                    </h2>
                </van-col>
            </van-row>
<!--            <van-cell style="padding-bottom: 0">-->
<!--                <van-row gutter="20">-->
<!--                    <van-col span="6" style=" overflow: hidden;white-space:nowrap;text-overflow: ellipsis;font-weight: bold;font-size: 16px">-->
<!--                        出库明细-->
<!--                    </van-col>-->
<!--                    <van-col span="18" class="ellipsisRight">-->
<!--                        合计：{{pacTotalCount}}包，{{totalCount}}件，重量{{ (totalWeight / 1000).toFixed(3) }}吨-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--            </van-cell>-->
            <van-list
                    v-model="detailLoading"
                    :finished="detailFinished"
                    finished-text="没有更多了"
            >
                <div v-for="pn in packageNo" :key="pn.packageNo">
                    <van-row gutter="20" v-if="pn.title!='无包装'" style="background: #fee7c5;padding: 5px 16px;font-size: 14px">
                        <van-col span="8" v-if="pn.title!='无包装'" class="ellipsis">
                            包装号:
                        </van-col>
                        <van-col span="16" class="ellipsisRight">
                            {{pn.title.replace("undefined","")}}
                        </van-col>

                    </van-row>
<!--                    <van-row gutter="20" v-if="pn.title!='无包装'" style="background: #f7f8fa;">-->
<!--                        <van-col span="24" v-if="pn.title!='无包装'" class="ellipsis"-->
<!--                                 style="text-align: left;word-break:keep-all;white-space:nowrap;font-weight: bold">-->
<!--                            包装号:{{pn.title.replace("undefined","")}}-->
<!--                        </van-col>-->
<!--                    </van-row>-->
                    <div class="van-cell-group van-hairline--top-bottom" v-for="item in pn.child" :key="item.instockDetailId">
                        <div class="van-cell">
                            <div class="van-cell__title"><span>物料号/钢卷号</span></div>
                            <div class="van-cell__value"><span>{{ item.cargoNumber }}/{{ item.tscNumber }}</span></div>
                        </div>
                        <div class="van-cell">
                            <div class="van-cell__title" style="width: 50px"><span>品名</span></div>
                            <div class="van-cell__value"><span>
                            {{ item.cargoProcessName }}/{{ item.cargoMaterialName }}/{{
                                        item.cargoThickness == null ? '' : item.cargoThickness
                                        }}x{{ item.cargoWidth == null ? '' : item.cargoWidth }}x{{ item.cargoLength |
                                        getCargoLength }}/{{ item.cargoOriginName }}/{{ item.surfaceName }}
                        </span></div>
                        </div>
                        <div class="van-cell">
                            <div class="van-cell__title"><span>件数/重量</span></div>
                            <div class="van-cell__value"><span>{{ item.outnotifyAmount }}件/{{ item.outnotifyWeight }}公斤</span></div>
                        </div>
                    </div>
                </div>



<!--                <van-cell v-for="pn in packageNo" :key="pn.packageNo" style="background: #f2f3f5;">-->
<!--                    <van-row gutter="20" v-if="pn.title!='无包装'" style="background: #f7f8fa;">-->
<!--                        <van-col span="24" v-if="pn.title!='无包装'" class="ellipsis"-->
<!--                                 style="text-align: left;word-break:keep-all;white-space:nowrap;font-weight: bold">-->
<!--                            包装号:{{pn.title.replace("undefined","")}}-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                    <van-row gutter="20">-->
<!--                        <van-col span="24" class="ellipsis">-->
<!--                            <van-cell v-for="item in pn.child" :key="item.instockDetailId">-->
<!--                                &lt;!&ndash;                        <van-row gutter="20" v-if="item.packageNo != '无包装'">&ndash;&gt;-->
<!--                                &lt;!&ndash;                          <van-col span="10" class="ellipsis">&ndash;&gt;-->
<!--                                &lt;!&ndash;                            包装号&ndash;&gt;-->
<!--                                &lt;!&ndash;                          </van-col>&ndash;&gt;-->
<!--                                &lt;!&ndash;                          <van-col span="14" class="ellipsisRight">&ndash;&gt;-->
<!--                                &lt;!&ndash;                            {{ item.packageNo }}&ndash;&gt;-->
<!--                                &lt;!&ndash;                          </van-col>&ndash;&gt;-->
<!--                                &lt;!&ndash;                        </van-row>&ndash;&gt;-->
<!--                                <van-row gutter="20" style="color: #727272">-->
<!--                                    <van-col span="8" class="ellipsis">-->
<!--                                        物料号/钢卷号-->
<!--                                    </van-col>-->
<!--                                    <van-col span="16" class="ellipsisRight">-->
<!--                                        {{ item.cargoNumber }}/{{ item.tscNumber }}-->
<!--                                    </van-col>-->
<!--                                </van-row>-->
<!--                                <van-row gutter="20" style="color: #727272">-->
<!--                                    <van-col span="3" class="ellipsis">-->
<!--                                        品名-->
<!--                                    </van-col>-->
<!--                                    <van-col span="21" class="ellipsisRight">-->
<!--                                        {{ item.cargoProcessName }}/{{ item.cargoMaterialName }}/{{-->
<!--                                        item.cargoThickness == null ? '' : item.cargoThickness-->
<!--                                        }}x{{ item.cargoWidth == null ? '' : item.cargoWidth }}x{{ item.cargoLength |-->
<!--                                        getCargoLength }}/{{ item.cargoOriginName }}/{{ item.surfaceName }}-->
<!--                                    </van-col>-->
<!--                                </van-row>-->
<!--                                <van-row gutter="20" style="color: #727272">-->
<!--                                    <van-col span="10" class="ellipsis">-->
<!--                                        件数/重量-->
<!--                                    </van-col>-->
<!--                                    <van-col span="14" class="ellipsisRight">-->
<!--                                        {{ item.outnotifyAmount }}件/{{ item.outnotifyWeight }}公斤-->
<!--                                    </van-col>-->
<!--                                </van-row>-->
<!--                            </van-cell>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                </van-cell>-->
            </van-list>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {
            showStatus() {
                return function (item) {
                    if (item.status == 30) {
                        return "done";
                    } else {
                        if (item.balanceStatus == 0) {
                            return "unpay";
                        } else {
                            return "pay"
                        }
                    }
                }
            },
            showDetailStatus() {
                return function (item) {
                    if (item.status == 30) {
                        return "done";
                    } else if (item.status == 20) {
                        return "verify"
                    }
                }
            },
            showMoney() {
                return function (cash) {
                    return Math.round((cash + Number.EPSILON) * 100) / 100;
                }
            }
        },
        data() {
            return {
                show: true,//nav bar
                list: [],
                detailList: [],
                loading: true,
                detailLoading: true,
                finished: false,
                detailFinished: false,
                searchValue: {
                    modelHType: 10,
                    modelKType: 10,
                    modelCType: 10,
                    modelH: "",
                    modelC: "",
                    modelK: "",
                },
                selCargoProcessName: "",
                selCargoMaterialName: "",
                cargoOriginName: "",
                surfaceName: "",
                showPickerCar: false,
                showPickerMat: false,
                showPickerOri: false,
                showPickerSur: false,
                showPickerIns: false,
                showPickerSta: false,
                showPickerMode: false,
                selWcode: "",
                status: "",
                selPcmode: "",
                cargoProcessData: [],
                cargoMaterialData: [],
                cargoOriginData: [],
                surfaceData: [],
                pcmodeData: [{value: undefined},
                    {value: '10'},
                    {value: '20'},
                    {value: '30'},
                    {value: '40'},
                    {value: '50'},
                ],
                pcmodeCol: ['全部', '原料', '余料', '成品', '废料', '尾板'],
                statusCol: ['审核', '完结'],
                cargocolCK: [],
                cargoNamecol: [],
                cargoMaterialcol: [],
                cargoOrigincol: [],
                surfaceCol: [],
                statusData: [
                    {value: '10'},
                    {value: '20'},
                    {value: '30'},
                ],
                searchShowPop: false,
                searchDetailPop: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoading: false,
                page: 1,
                pageSize: 20,
                //日期选择calendarShow
                calendarShow: false,
                sumAmount: 0,
                sumWeight: 0,
                outCount: 0,
                packageNo: [],
                outnotifyNo: '',
                outnotifyStatus: '',
                outnotifyCustomerNo: '',
                deliveryTrucknumber: '',
                deliveryName: '',
                effectiveDate: '',
                remarks: '',
                confirmTime: '',
                pacTotalCount: 0,
                totalCount: 0,
                totalWeight: 0,
            }
        },
        mounted() {
            this.onLoad();
            let parm = {};
            parm.ouid = localStorage.getItem("ouid")
            service.selCargoProcessP(parm).then(res => {
                let data = res.data;
                this.cargoProcessData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.cargoNamecol.push(data[i].cargoProcessName)
                }
            })
            service.selCargoMaterialProcessG(parm).then(res => {
                let data = res.data;
                this.cargoMaterialData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.cargoMaterialcol.push(data[i].cargoMaterialName)
                }
            })
            service.selCargoOriginProcessG(parm).then(res => {
                let data = res.data;
                this.cargoOriginData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.cargoOrigincol.push(data[i].cargoOriginName)
                }
            })
            service.selSurfaceNameG(parm).then(res => {
                let data = res.data;
                this.surfaceData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.surfaceCol.push(data[i].surfaceName)
                }
            })
        },
        filters: {
            formatStatus(status) {
                if (status == null) {
                    return '';
                } else {
                    if (status == 10) {
                        return '新建';
                    } else if (status == 20) {
                        return '审核';
                    } else if (status == 30) {
                        return '完结';
                    }
                }
            },
            getCargoLength(cargoLength) {
                if (cargoLength == null) {
                    return 'C';
                } else {
                    if (cargoLength == 0) {
                        return 'C';
                    } else {
                        if (cargoLength > 10000) {
                            return cargoLength / 1000 + 'm'
                        } else {
                            return cargoLength
                        }
                    }
                }
            },
            getPosition(item) {
                let {
                    wcode,
                    acode,
                    pcode,
                } = item

                if (wcode != null && acode != null && pcode != null) {
                    return wcode + "/" + acode + "/" + pcode;
                } else if (wcode != null && acode != null) {
                    return wcode + "/" + acode;
                } else if (wcode != null) {
                    return wcode;
                } else {
                    return '';
                }
            }
        },
        methods: {
            showDetail(flag, item) {
                this.searchDetailPop = flag
                this.detailList = []
                if (flag) {
                    this.searchJgOutstockDetailByOutnotifyId(item.outnotifyId)
                    this.outnotifyNo = item.outnotifyNo
                    this.outnotifyStatus = item.status
                    this.confirmTime = this.$moment(item.confirmTime).format("YYYY-MM-DD HH:mm:ss")
                    this.outnotifyCustomerNo = item.outnotifyCustomerNo
                    this.deliveryTrucknumber = item.deliveryTrucknumber
                    this.deliveryName = item.deliveryName
                    this.effectiveDate = this.$moment(item.effectiveDate).format("YYYY-MM-DD")
                    this.remarks = item.remarks
                }
            },
            searchJgOutstockDetailByOutnotifyId(outnotifyId) {
                service.searchJgOutstockDetailByOutnotifyId({outnotifyId: outnotifyId}).then((res) => {
                    this.packageNo = [];
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            let totalCount = 0;
                            let pacTotalCount = 0;
                            let totalWeight = 0;
                            let packageNo = [];
                            let packageIdList = [];
                            res.data.forEach(item => {
                                let str = item.packageNo;
                                if (str == undefined) {
                                    packageNo.push("无包装")
                                } else {
                                    packageNo.push(str)
                                }

                                if (item.processtaskPackageId != null) {
                                    if (packageIdList.indexOf(item.processtaskPackageId) == -1) {
                                        pacTotalCount = pacTotalCount + 1
                                        packageIdList.push(item.processtaskPackageId)
                                    }
                                }
                                totalCount += item.outnotifyAmount
                                totalWeight += item.outnotifyWeight
                            });
                            this.pacTotalCount = pacTotalCount
                            this.totalCount = totalCount
                            this.totalWeight = totalWeight

                            packageNo = Array.from(new Set(packageNo));

                            packageNo.forEach(item => {
                                let child = []
                                res.data.forEach(p => {
                                    if (p.packageNo == undefined) {
                                        p.packageNo = "无包装";
                                    }
                                    if (item == p.packageNo) {
                                        child.push(p)
                                    }
                                })
                                let one = child[0]
                                let title = "";
                                if (one.packageNo == "无包装") {
                                    title = one.packageNo
                                } else {
                                    title = one.packageNo + "（" + one.packageName + "）"
                                }

                                this.packageNo.push({"packageNo": item, "title": title, "child": child})
                            });
                            // for (let i = 0; i < res.data.length; i++) {
                            //   this.detailList.push(res.data[i]);
                            // }
                        } else {
                            this.detailFinished = true;
                        }
                        this.detailLoading = false;
                        this.detailFinished = true;
                    } else {
                        this.detailLoading = false;
                        this.detailFinished = true;
                        Toast(res.msg)
                    }
                })
            },
            showPicker(pickerName) {
                this.calendarShow = false
                this.showPickerSta = false
                this.showPickerCar = false
                this.showPickerMode = false
                this.showPickerMat = false
                this.showPickerOri = false
                this.showPickerSur = false

                switch (pickerName) {
                    case 'calendarShow':
                        this.calendarShow = true
                        break
                    case 'showPickerSta':
                        this.showPickerSta = true
                        break
                    case 'showPickerCar':
                        this.showPickerCar = true
                        break
                    case 'showPickerMode':
                        this.showPickerMode = true
                        break
                    case 'showPickerMat':
                        this.showPickerMat = true
                        break
                    case 'showPickerOri':
                        this.showPickerOri = true
                        break
                    case 'showPickerSur':
                        this.showPickerSur = true
                        break
                    default:
                        return false
                }
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            selCargoProcessVal(value, index) {
                this.selCargoProcessName = value;
                this.searchValue.cargoProcessId = this.cargoProcessData[index].cargoProcessId
                this.showPickerCar = false;
            },
            selCargoMaterialVal(value, index) {
                this.selCargoMaterialName = value;
                this.searchValue.cargoMaterialId = this.cargoMaterialData[index].cargoMaterialId
                this.showPickerMat = false;
            },
            selCargoOriginVal(value, index) {
                this.cargoOriginName = value;
                this.searchValue.cargoOriginId = this.cargoOriginData[index].cargoOriginId
                this.showPickerOri = false;
            },
            selSurfaceVal(value, index) {
                this.surfaceName = value;
                this.searchValue.surfaceId = this.surfaceData[index].surfaceId
                this.showPickerSur = false;
            },
            selStatusVal(value, index) {
                this.status = value;
                this.searchValue.status = this.statusData[index].value
                this.showPickerSta = false;
            },
            selPcmodeVal(value, index) {
                this.selPcmode = value;
                this.searchValue.pcmode = this.pcmodeData[index].value
                this.showPickerMode = false;
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.show = true;
                this.searchShowPop = false;
                this.onLoad();
            },
            onLoad() {
                this.getDetailList();
                // this.getTotalCount();
            },
            getDetailList() {
                let createTimeStart = "";
                let createTimeEnd = "";
                let dateStr = this.searchValue
                if (dateStr != null && dateStr != "" && this.searchValue.startDate != "" && this.searchValue.endDate != "") {
                    createTimeStart = this.searchValue.startDate;
                    createTimeEnd = this.searchValue.endDate
                }

                let searchObj = this.searchValue
                searchObj.startDate = createTimeStart
                searchObj.endDate = createTimeEnd
                searchObj.page = this.page;
                searchObj.size = this.pageSize;
                searchObj.ouid = localStorage.getItem("ouid")
                searchObj.customerId = localStorage.getItem("customerId")

                if (searchObj.modelH != "") {
                    let index = searchObj.modelH.indexOf("-");
                    if (index >= 0) {
                        searchObj.modelHType = 20;
                        let spList = searchObj.modelH.split("-");
                        searchObj.modelHStrat = spList[0];
                        searchObj.modelHEnd = spList[1];
                    } else {
                        searchObj.modelHType = 10;
                    }
                }

                if (searchObj.modelK != "") {
                    let index = searchObj.modelK.indexOf("-");
                    if (index >= 0) {
                        searchObj.modelKType = 20;
                        let spList = searchObj.modelK.split("-");
                        searchObj.modelKStrat = spList[0];
                        searchObj.modelKEnd = spList[1];
                    } else {
                        searchObj.modelKType = 10;
                    }
                }

                if (searchObj.modelC != "") {
                    let index = searchObj.modelC.indexOf("-");
                    if (index >= 0) {
                        searchObj.modelCType = 20;
                        let spList = searchObj.modelC.split("-");
                        searchObj.modelCStrat = spList[0];
                        searchObj.modelCEnd = spList[1];
                    } else {
                        searchObj.modelCType = 10;
                    }
                }
                service.searchJgOutInstockTotal(JSON.parse(JSON.stringify(searchObj))).then(res => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.msg)
                    }
                })
            },
            getTotalCount() {
                let createTimeStart = "";
                let createTimeEnd = "";
                let dateStr = this.searchValue
                if (dateStr != null && dateStr != "" && this.searchValue.startDate != "" && this.searchValue.endDate != "") {
                    createTimeStart = this.searchValue.startDate;
                    createTimeEnd = this.searchValue.endDate
                }

                let searchObj = this.searchValue
                searchObj.startDate = createTimeStart
                searchObj.endDate = createTimeEnd
                searchObj.page = null;
                searchObj.size = null;
                searchObj.ouid = localStorage.getItem("ouid")
                searchObj.customerId = localStorage.getItem("customerId")
                if (searchObj.modelH != "") {
                    let index = searchObj.modelH.indexOf("-");
                    if (index >= 0) {
                        searchObj.modelHType = 20;
                        let spList = searchObj.modelH.split("-");
                        searchObj.modelHStrat = spList[0];
                        searchObj.modelHEnd = spList[1];
                    } else {
                        searchObj.modelHType = 10;
                    }
                }

                if (searchObj.modelK != "") {
                    let index = searchObj.modelK.indexOf("-");
                    if (index >= 0) {
                        searchObj.modelKType = 20;
                        let spList = searchObj.modelK.split("-");
                        searchObj.modelKStrat = spList[0];
                        searchObj.modelKEnd = spList[1];
                    } else {
                        searchObj.modelKType = 10;
                    }
                }

                if (searchObj.modelC != "") {
                    let index = searchObj.modelC.indexOf("-");
                    if (index >= 0) {
                        searchObj.modelCType = 20;
                        let spList = searchObj.modelC.split("-");
                        searchObj.modelCStrat = spList[0];
                        searchObj.modelCEnd = spList[1];
                    } else {
                        searchObj.modelCType = 10;
                    }
                }
                let _this = this;
                service.searchJgOutInstockSumData(searchObj).then(res => {
                    if (res.data != null) {
                        _this.sumWeight = res.data.sumWeight;
                        _this.sumAmount = res.data.sumAmount;
                        _this.outCount = res.data.outCount;
                    } else {
                        _this.sumWeight = '--';
                        _this.sumAmount = '--';
                        _this.outCount = '--';
                    }
                })
            },
            searchPop() {
                this.show = true;
                this.searchShowPop = true;
            },
            onRefresh() {
                this.onLoad();
            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date) {
                const [start, end] = date;
                this.calendarShow = false;
                this.searchValue.instockDate = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                this.searchValue.startDate = this.$moment(start).format("YYYY-MM-DD");
                this.searchValue.endDate = this.$moment(end).format("YYYY-MM-DD");
            },
            resetSearch() {
                this.searchValue = {
                    modelHType: 10,
                    modelKType: 10,
                    modelCType: 10,
                    modelH: "",
                    modelC: "",
                    modelK: "",
                    key: "",
                };
                this.selCargoProcessName = "";
                this.selCargoMaterialName = "";
                this.cargoOriginName = "";
                this.surfaceName = "";
                this.selWcode = ""
                this.status = ""
                this.selPcmode = ""
            },
            conventStatus(item) {
                // 10新建、20审核、30完结
                if (item.status == "10") {
                    return "新建"
                } else if (item.status == "20") {
                    return "审核"
                } else if (item.status == "30") {
                    return "完结"
                } else if (item.status == "40") {
                    return "出库"
                }
            }
        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .hejcss {
        background-color: #f7f8fa;
        font-size: 15px;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 56px auto;
    }

    .editwarp .swipewarp {
        margin-bottom: 10px;
    }

    .contentwarp {
        margin-top: 50px;
        height: calc(100vh - 50px);
    }

    .detailHeader {
        background-color: #1989fa;
        height: 70px;
        text-align: center;
        padding-top: 20px;
        margin-bottom: 20px;
        color: white;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .detailLabel {
        color: #727272;
    }

    .detailLabel.detailtitle {
        color: #323233;
        font-weight: bold;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;
    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;
    }

    /deep/ .ewm .van-button--info {
        border: 1px solid #6685a4;
        width: 200px
    }


    .searchwarp[data-v-1405fac1] {
        margin-top: 56px;
    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }

    /*.van-cell::after{
        border-bottom: none;
    }*/
    .van-icon.van-icon-arrow {
        vertical-align: middle;
        margin-left: 5px;
    }

    .van-grid {
        padding: 10px;
    }

    /deep/ .van-image__img {
        border: #e4ebf3 1px solid;
    }

    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
    }

    .van-button--default {
        border: 1px solid #e2e2e2;
    }

    .van-divider {
        margin: 0px !important;
    }


    /deep/ .thmx > .van-row {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    /deep/ .van-cell__value.van-cell__value--alone > .thmx:last-child > .van-row {
        padding-top: 10px;
        padding-bottom: 0;
    }

    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 32px;
    }

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }

    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }
    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 1);
        font-weight: bold;
        font-size: 15px;
        line-height: 16px;
        text-align: left;
    }
    /deep/ .van-cell__title{
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex:unset;
        flex:unset;
        width: 100px;
        color: #969799;
    }
    /deep/ .van-cell__value{
        color: #323233;
    }
    .van-list .van-cell-group::after {
        border-bottom-width: 5px;
    }
    /deep/ .van-cell__title.van-field__label.van-field__label--right{
        text-align: right;
    }
    .van-cell{
        padding: 8px 16px;
        font-size: 15px;
    }
</style>